// Lightweight client-side ULID — monotonic within a tick, good enough for
// optimistic IDs that'll be regenerated server-side if needed. For subtask
// IDs (local-only, not persisted through conflict), the naïve version is fine.
const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export function ulid(): string {
  const time = Date.now();
  let timeStr = '';
  let t = time;
  for (let i = 9; i >= 0; i--) {
    timeStr = ALPHABET[t % 32]! + timeStr;
    t = Math.floor(t / 32);
  }
  let rand = '';
  for (let i = 0; i < 16; i++) {
    rand += ALPHABET[Math.floor(Math.random() * 32)]!;
  }
  return timeStr + rand;
}
